<template>
	<LayoutTableCommonRow>
		<LayoutTableCommonPartText :text="goal.name" :header="header" />
		<LayoutTableCommonPartMenu>
			<template #options>
				<router-link :to="{ name: 'company.admin.goal.period.index', params: { id: goal.id }}" class="dropdown-item rounded-0">Períodos</router-link>
				<router-link :to="{ name: 'company.admin.goal.stat', params: { id: goal.id }}" class="dropdown-item rounded-0">Estadísticas</router-link>
				<router-link :to="{ name: 'company.admin.goal.form', params: { id: goal.id }}" class="dropdown-item rounded-0" v-if="goal.periods_processed == 0">Editar</router-link>
				<a href="javascript:void(0)" class="dropdown-item rounded-0" @click="remove">Eliminar</a>
				<template v-if="goal.periods_processed > 0">
					<div class="dropdown-divider"></div>
					<div class="dropdown-item-text py-1 rounded-0 lh-xs text-danger">No puedes modificar esta meta porque contiene períodos ya procesados.</div>
				</template>
			</template>
		</LayoutTableCommonPartMenu>
	</LayoutTableCommonRow>
</template>

<script>
	import { computed } from 'vue';

	export default {
		emits: ['remove'],
		props: {
			goal: Object
		},
		setup(props, { emit }) {
			const remove = () => emit('remove', props.goal);

			const header = computed(() => {
				let data = null;

				if(props.goal.periods_count == 0) data = `Sin períodos cargados`;
				else if(props.goal.periods_count == 1) data = `1 período cargado`;
				else data = `${props.goal.periods_count} períodos cargados`;

				return data;
			});

			return { remove, header };
		}
	}
</script>